import { createReducer } from '@reduxjs/toolkit';

import { LOANS_STATUS } from '../../constants/constants';
import { CreditDetailsStateType } from '../../types';
import {
  getCreditDetails,
  setCreditDetailsLoading,
} from '../actions/credit-details';

const initialState: CreditDetailsStateType = {
  data: {
    details: {
      id: 0,
      accountId: 0,
      transactionId: 0,
      amount: 0,
      percent: 0,
      status: LOANS_STATUS.SIGNED,
      appliedAt: new Date(),
      deadlineAt: new Date(),
      delta: 0,
      createdAt: new Date(),
      creditor: '',
      creditorTin: '',
      paymentSum: 0,
      paymentDate: new Date(),
    },
  },
  loading: {
    details: false,
    close: false,
    getCredits: false,
  },
};

const creditDetailsReducer = createReducer(initialState, (builder) => {
  builder.addCase(setCreditDetailsLoading, (state, action) => {
    state.loading[action.payload.name] = action.payload.value;
  });

  builder.addCase(getCreditDetails.fulfilled, (state, action) => {
    if (action.payload) state.data.details = action.payload;
  });
});

export default creditDetailsReducer;
